import { render } from "./ListadoTransferenciasPage.vue?vue&type=template&id=35791ff4&scoped=true"
import script from "./ListadoTransferenciasPage.vue?vue&type=script&lang=js"
export * from "./ListadoTransferenciasPage.vue?vue&type=script&lang=js"

import "./ListadoTransferenciasPage.vue?vue&type=style&index=0&id=35791ff4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35791ff4"]])

export default __exports__